/**
 * @requires HBS
 */
(function() {
	/**
	 * @exports ASM.main
	 */
	let module = {};

	/**
	 * Global init code for the whole application
	 */
	module.init = () => {
		module.addModernizrTests();
		module.fullWidthContainerFix();
		module.modulesSetup();
		module.externalLinks();
	};

	module.fullWidthContainerFix = () => {
		let el = document.createElement('div');
		el.setAttribute('style', 'width:100%');
		document.body.appendChild(el);
		let constrainedWidth = el.offsetWidth;

		el.setAttribute('style', 'width:100vw');
		let fullWidth = el.offsetWidth;
		let scrollbarWidth = Math.ceil(fullWidth - constrainedWidth);
		document.documentElement.style.setProperty(
			'--scrollbar-width',
			scrollbarWidth + 'px'
		);

		document.body.removeChild(el);
	};

	module.externalLinks = function () {
		for (var c = document.getElementsByTagName("a"), a = 0; a < c.length; a++) {
			var b = c[a];
			b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank");
		}
	};

	module.addModernizrTests = () => {
		Modernizr.addTest('coarsepointer', function () {
			return Modernizr.mq('(pointer: coarse)') && !Modernizr.mq('(any-pointer: fine)');
		});

		Modernizr.addTest('ie11', function () {
			if(!!window.MSInputMethodContext && !!document.documentMode) {
				return true;
			} else {
				return false; //
			}
		});
	};

	module.setupMainNav = () => {
		let searchTrigger = document.querySelector('.js-search-trigger');
		let searchForm = document.querySelector('.js-search-wrapper');

		searchTrigger.addEventListener('click', (e) => {
			e.preventDefault();

			if(searchForm && searchForm.classList.contains('state-open')) {
				searchForm.classList.remove('state-open');
				searchTrigger.classList.remove('state-open');
			} else {
				searchTrigger.classList.add('state-open');
				searchForm.classList.add('state-open');
			}
		});

		enquire.register("screen and (max-width:991px)", {
			match : () => {
				module.setupMobileNav()
			},
			unmatch : () => {
				module.setupDesktopNav();
			}
		});
	};

	module.setupMobileNav = () => {
		console.log('setup Mobile Nav ran');
	};

	module.setupDesktopNav = () => {
		console.log('setup Desktop Nav ran');
	};

	module.aos = () => {
		AOS.init();
	};

	module.balanceText = () => {
		if(document.querySelectorAll('.balance-text').length) {
			balanceText();
		}
	};

	module.sidenavSetup = () => {
		let listPageNavs = document.querySelectorAll('.sidebar__list .page_item .js-subnav-wrap');
		let topLevelPageLinks = document.querySelectorAll('.sidebar__list > li.page_item_has_children');

		listPageNavs.forEach((nav) => {
			let parent = nav.parentElement;
			parent.after(nav);
		});

		//add arrows to top level pages
		topLevelPageLinks.forEach((link) => {
			let trigger = document.createElement("a");   // Create a <button> element
			trigger.classList.add('sidebar__link-trigger');
			trigger.classList.add('js-trigger-top-level');
			trigger.setAttribute('href', '#');
			let spanIcon = document.createElement("span");
			spanIcon.classList.add('icon-chevron-down');
			trigger.appendChild(spanIcon);
			link.appendChild(trigger);

			//on normal pages with sidebar wrap children elements for use with dropdowns
			if(link.querySelector('ul.children')) {
				let childList = link.querySelector('ul.children');
				let subnavWrapper = document.createElement("div");
				subnavWrapper.classList.add('sidebar__second-level-wrapper');
				subnavWrapper.classList.add('js-subnav-wrap');
				link.after(subnavWrapper);
				link.appendChild(childList);
			}
		});

		let topLevelTriggers = document.querySelectorAll('.js-trigger-top-level');

		//add arrows to menu
		topLevelTriggers.forEach((trigger) => {
			let parentLi = trigger.parentElement;
			let menu = parentLi.nextElementSibling;

			trigger.addEventListener('click', (event) => {
				event.preventDefault();
				if(trigger.classList.contains('state-open')) {
					trigger.classList.remove('state-open')
				} else {
					trigger.classList.add('state-open');
				}

				//if our nav menu is the next sibling
				if(menu && menu.classList.contains('js-subnav-wrap')) {
					if(menu.classList.contains('state-open')) {
						menu.classList.remove('state-open');
					} else {
						menu.classList.add('state-open');
					}
				}
			});
		});

		//wp-list-pages is also used to build the nav and does its own thing

	};

	module.openMenu = (triggerElement, menuElement) => {

	};

	module.modulesSetup = () => {
		module.aos();
		module.balanceText();
		module.setupMainNav();
		module.sidenavSetup();
	};

	/**
	 * Initialize the app and run the bootstrapper
	 */
	var docReady = (callback) => {
		// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
			// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			// IE <= 8
			document.attachEvent('onreadystatechange', () => {
				if (document.readyState === 'complete') callback();
			});
		}
	};

	docReady(() => {
		module.init();
		HBS.initPage();
	});

	HBS.namespace('ASM.main', module);
}());